import { useState } from "react";
// import oo from "../../images/01.jpg"

const ReviewDesc = () => {
  const reviewtitle = "Add a Review";

  let ReviewList = [
    {
      imgUrl: "/reviews/01.jpg",
      imgAlt: "Client thumb",
      name: "Ganelon Boileau",
      date: "Posted on Jun 10, 2022 at 6:57 am",
      desc: "Enthusiast build innovativ initiatives before lonterm high-impact awesome theme seo psd porta monetize covalent leadership after without resource.",
    },
    {
      imgUrl: "/reviews/02.jpg",
      imgAlt: "Client thumb",
      name: "Morgana Cailot",
      date: "Posted on Jun 10, 2022 at 6:57 am",
      desc: "Enthusiast build innovativ initiatives before lonterm high-impact awesome theme seo psd porta monetize covalent leadership after without resource.",
    },
    {
      imgUrl: "/reviews/03.jpg",
      imgAlt: "Client thumb",
      name: "Telford Bois",
      date: "Posted on Jun 10, 2022 at 6:57 am",
      desc: "Enthusiast build innovativ initiatives before lonterm high-impact awesome theme seo psd porta monetize covalent leadership after without resource.",
    },
    {
      imgUrl: "/reviews/04.jpg",
      imgAlt: "Client thumb",
      name: "Cher Daviau",
      date: "Posted on Jun 10, 2022 at 6:57 am",
      desc: "Enthusiast build innovativ initiatives before lonterm high-impact awesome theme seo psd porta monetize covalent leadership after without resource.",
    },
  ];

  const [review, setReview] = useState(true);
  const [description, setDescription] = useState(false);
  return (
    <div className="shadow-lg rounded-[5px] px-[40px] my-[20px] py-[70px] relative">
      <div className="flex items-center gap-3 mb-[40px] absolute top-0 left-0">
        <button
          onClick={() => {
            setDescription(!description);
            setReview(!review);
          }}
          className={`py-[5px] px-[10px] w-[100px] rounded-[2px] ${
            description ? "bg-amber-500 text-white" : "bg-gray-500 text-white"
          }`}
        >
          Description
        </button>
        <button
          onClick={() => {
            setDescription(!description);
            setReview(!review);
          }}
          className={`py-[5px] px-[10px] w-[100px] rounded-[2px] ${
            review ? "bg-amber-500 text-white" : "bg-gray-500 text-white"
          }`}
        >
          Review
        </button>
      </div>

      {/* Description */}
      <div className={`${description ? "block" : "hidden"}`}>
        <h4 className="font-[600] text-[18px]">Description</h4>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repudiandae
          sapiente perspiciatis iure maxime aut recusandae expedita ipsum eum?
          Quae facilis saepe dolorum, adipisci id eaque dolore suscipit beatae
          inventore quod?
        </p>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repudiandae
          sapiente perspiciatis iure maxime aut recusandae expedita ipsum eum?
          Quae facilis saepe dolorum, adipisci id eaque dolore suscipit beatae
          inventore quod?
        </p>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repudiandae
          sapiente perspiciatis iure maxime aut recusandae expedita ipsum eum?
          Quae facilis saepe dolorum, adipisci id eaque dolore suscipit beatae
          inventore quod?
        </p>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Repudiandae
          sapiente perspiciatis iure maxime aut recusandae expedita ipsum eum?
          Quae facilis saepe dolorum, adipisci id eaque dolore suscipit beatae
          inventore quod?
        </p>
        <h4 className="font-[600] text-[18px] mt-[20px]">Specification</h4>
        <ul className="list-disc">
          <li>Dual Sense wireless controller</li>
          <li>
            Lightning Speed ​​- Harness the power of a custom CPU, GPU, and SSD
            with Integrated I/O that rewrite the rules of what a PlayStation
            console can do.
          </li>
          <li>
            Stunning Games - Marvel at incredible graphics and experience new
            PS5 features.
          </li>
        </ul>
      </div>
      {/* Review */}
      {review ? (
        <div className="flex flex-col gap-[25px]">
          {ReviewList.map((reviews, i) => (
            <div
              key={i}
              className="flex flex-col lg:flex-row items-start gap-[30px] py-[20px]"
            >
              <img
                src={reviews.imgUrl}
                alt={reviews.imgAlt}
                className="h-[70px]"
              />
              <div className="border-b-[1px] border-gray-200 pb-[20px]">
                <h5 className="font-[500]">{reviews.date}</h5>
                <p className="text-gray-400 text-[18px]">{reviews.desc}</p>
              </div>
            </div>
          ))}
          {/* Review content */}
          <div>
            <h3 className="font-[600] relative before:absolute before:top-[30px] before:content-[''] before:h-[3px] before:w-[90px] before:bg-amber-500 before:rounded-md">
              {reviewtitle}
            </h3>
            <form action="action" className="mt-[25px]">
              <div className="flex flex-col lg:flex-row gap-3 mb-[20px]">
                <input
                  type="text"
                  name="fullname"
                  placeholder="Enter your full name"
                  className="w-[100%] lg:w-[35%] border-[1px] border-gray-300 rounded-[5px] px-[5px] py-[10px]"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  className="w-[100%] lg:w-[35%] border-[1px] border-gray-300 rounded-[5px] px-[5px] py-[10px]"
                />
                <div className="hidden w-[30%] lg:flex gap-2">
                  <p>Your Rating</p>
                  <span className="text-amber-500">
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </span>
                </div>
              </div>
              <textarea
                name="message"
                id="message"
                placeholder="Write your review"
                rows={7}
                className="w-[100%] border-[1px] border-gray-300 rounded-[5px] px-[5px] py-[5px]"
              ></textarea>
              <button
                type="submit"
                className="mt-[10px] bg-amber-500 text-white py-[9px] px-[9px] rounded-[2px] font-[600]"
              >
                Submit Review
              </button>
            </form>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default ReviewDesc;
